"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * @author armen.avagumyan on 5/24/2017.
 */
var Framework = /** @class */ (function () {
    //constructors
    function Framework() {
    }
    Object.defineProperty(Framework.prototype, "id", {
        //getters/setters
        get: function () {
            return this._id;
        },
        set: function (value) {
            this._id = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Framework.prototype, "name", {
        get: function () {
            return this._name;
        },
        set: function (value) {
            this._name = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Framework.prototype, "kbFrameworkSystemName", {
        get: function () {
            return this._kbFrameworkSystemName;
        },
        set: function (value) {
            this._kbFrameworkSystemName = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Framework.prototype, "isGlobal", {
        get: function () {
            return this._isGlobal;
        },
        set: function (value) {
            this._isGlobal = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Framework.prototype, "isPublic", {
        get: function () {
            return this._isPublic;
        },
        set: function (value) {
            this._isPublic = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Framework.prototype, "ownerUserId", {
        get: function () {
            return this._ownerUserId;
        },
        set: function (value) {
            this._ownerUserId = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Framework.prototype, "updatedUserId", {
        get: function () {
            return this._updatedUserId;
        },
        set: function (value) {
            this._updatedUserId = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Framework.prototype, "dateUpdated", {
        get: function () {
            return this._dateUpdated;
        },
        set: function (value) {
            this._dateUpdated = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Framework.prototype, "masters", {
        get: function () {
            return this._masters;
        },
        set: function (value) {
            this._masters = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Framework.prototype, "items", {
        get: function () {
            return this._items;
        },
        set: function (value) {
            this._items = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Framework.prototype, "levels", {
        get: function () {
            return this._levels;
        },
        set: function (value) {
            this._levels = value;
        },
        enumerable: true,
        configurable: true
    });
    return Framework;
}());
exports.Framework = Framework;
var FrameworkLevel = /** @class */ (function () {
    //constructors
    function FrameworkLevel() {
    }
    Object.defineProperty(FrameworkLevel.prototype, "framework", {
        //getters/setters
        get: function () {
            return this._framework;
        },
        set: function (value) {
            this._framework = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FrameworkLevel.prototype, "frameworkId", {
        get: function () {
            return this._frameworkId;
        },
        set: function (value) {
            this._frameworkId = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FrameworkLevel.prototype, "id", {
        get: function () {
            return this._id;
        },
        set: function (value) {
            this._id = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FrameworkLevel.prototype, "level", {
        get: function () {
            return this._level;
        },
        set: function (value) {
            this._level = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FrameworkLevel.prototype, "enabled", {
        get: function () {
            return this._enabled;
        },
        set: function (value) {
            this._enabled = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FrameworkLevel.prototype, "nameTemplateId", {
        get: function () {
            return this._nameTemplateId;
        },
        set: function (value) {
            this._nameTemplateId = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FrameworkLevel.prototype, "deletedOn", {
        get: function () {
            return this._deletedOn;
        },
        set: function (value) {
            this._deletedOn = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FrameworkLevel.prototype, "deletedBy", {
        get: function () {
            return this._deletedBy;
        },
        set: function (value) {
            this._deletedBy = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FrameworkLevel.prototype, "name", {
        get: function () {
            return this._name;
        },
        set: function (value) {
            this._name = value;
        },
        enumerable: true,
        configurable: true
    });
    return FrameworkLevel;
}());
exports.FrameworkLevel = FrameworkLevel;
var FItem = /** @class */ (function () {
    //constructors
    function FItem() {
        this._isExpanded = null;
    }
    Object.defineProperty(FItem.prototype, "id", {
        //getters/setters
        get: function () {
            return this.data.getId();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FItem.prototype, "name", {
        get: function () {
            return this.data.getMultilingualName();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FItem.prototype, "parent", {
        get: function () {
            return this._parent;
        },
        set: function (value) {
            this._parent = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FItem.prototype, "level", {
        get: function () {
            return this._level;
        },
        set: function (value) {
            this._level = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FItem.prototype, "isExpanded", {
        get: function () {
            return this._isExpanded;
        },
        set: function (value) {
            this._isExpanded = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FItem.prototype, "data", {
        get: function () {
            return this._data;
        },
        set: function (value) {
            this._data = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FItem.prototype, "sortId", {
        get: function () {
            return this._sortId;
        },
        set: function (value) {
            this._sortId = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FItem.prototype, "referenceId", {
        get: function () {
            return this._referenceId;
        },
        set: function (value) {
            this._referenceId = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FItem.prototype, "items", {
        get: function () {
            return this._items;
        },
        set: function (value) {
            this._items = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FItem.prototype, "assignedIndicators", {
        get: function () {
            return this._assignedIndicators;
        },
        set: function (value) {
            var _this = this;
            value && value.forEach(function (indicator) { return indicator.item = _this; }); //set parent
            this._assignedIndicators = value;
        },
        enumerable: true,
        configurable: true
    });
    return FItem;
}());
exports.FItem = FItem;
var FItemIndicator = /** @class */ (function () {
    //constructors
    function FItemIndicator() {
    }
    Object.defineProperty(FItemIndicator.prototype, "id", {
        //getters/setters
        get: function () {
            return this._id;
        },
        set: function (value) {
            this._id = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FItemIndicator.prototype, "indicatorId", {
        get: function () {
            return this._indicatorId;
        },
        set: function (value) {
            this._indicatorId = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FItemIndicator.prototype, "item", {
        get: function () {
            return this._item;
        },
        set: function (value) {
            this._item = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FItemIndicator.prototype, "name", {
        get: function () {
            return this._name;
        },
        set: function (value) {
            this._name = value;
        },
        enumerable: true,
        configurable: true
    });
    return FItemIndicator;
}());
exports.FItemIndicator = FItemIndicator;
var FrameworkMaster = /** @class */ (function () {
    //constructors
    function FrameworkMaster() {
    }
    Object.defineProperty(FrameworkMaster.prototype, "framework", {
        //getters/setters
        get: function () {
            return this._framework;
        },
        set: function (value) {
            this._framework = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FrameworkMaster.prototype, "id", {
        get: function () {
            return this._id;
        },
        set: function (value) {
            this._id = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FrameworkMaster.prototype, "frameworkId", {
        get: function () {
            return this._frameworkId;
        },
        set: function (value) {
            this._frameworkId = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FrameworkMaster.prototype, "masterId", {
        get: function () {
            return this._masterId;
        },
        set: function (value) {
            this._masterId = value;
        },
        enumerable: true,
        configurable: true
    });
    return FrameworkMaster;
}());
exports.FrameworkMaster = FrameworkMaster;
var NameTemplate = /** @class */ (function () {
    //constructors
    function NameTemplate() {
    }
    Object.defineProperty(NameTemplate.prototype, "id", {
        //getters/setters
        get: function () {
            return this._id;
        },
        set: function (value) {
            this._id = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NameTemplate.prototype, "name", {
        get: function () {
            return this._name;
        },
        set: function (value) {
            this._name = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NameTemplate.prototype, "kbFrameworkSystemName", {
        get: function () {
            return this._kbFrameworkSystemName;
        },
        set: function (value) {
            this._kbFrameworkSystemName = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NameTemplate.prototype, "isGlobal", {
        get: function () {
            return this._isGlobal;
        },
        set: function (value) {
            this._isGlobal = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NameTemplate.prototype, "isPublic", {
        get: function () {
            return this._isPublic;
        },
        set: function (value) {
            this._isPublic = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NameTemplate.prototype, "deletedOn", {
        get: function () {
            return this._deletedOn;
        },
        set: function (value) {
            this._deletedOn = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NameTemplate.prototype, "deletedBy", {
        get: function () {
            return this._deletedBy;
        },
        set: function (value) {
            this._deletedBy = value;
        },
        enumerable: true,
        configurable: true
    });
    return NameTemplate;
}());
exports.NameTemplate = NameTemplate;
var FrameworkMeta = /** @class */ (function () {
    function FrameworkMeta() {
    }
    Object.defineProperty(FrameworkMeta.prototype, "systemName", {
        //getters/setters
        get: function () {
            return this._systemName;
        },
        set: function (value) {
            this._systemName = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FrameworkMeta.prototype, "name", {
        get: function () {
            return this._name;
        },
        set: function (value) {
            this._name = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FrameworkMeta.prototype, "categories", {
        get: function () {
            return this._categories;
        },
        set: function (value) {
            this._categories = value;
        },
        enumerable: true,
        configurable: true
    });
    return FrameworkMeta;
}());
exports.FrameworkMeta = FrameworkMeta;
var FrameworkCategoryMeta = /** @class */ (function () {
    function FrameworkCategoryMeta() {
    }
    Object.defineProperty(FrameworkCategoryMeta.prototype, "systemName", {
        //getters/setters
        get: function () {
            return this._systemName;
        },
        set: function (value) {
            this._systemName = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FrameworkCategoryMeta.prototype, "level", {
        get: function () {
            return this._level;
        },
        set: function (value) {
            this._level = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FrameworkCategoryMeta.prototype, "frameworkMeta", {
        get: function () {
            return this._frameworkMeta;
        },
        set: function (value) {
            this._frameworkMeta = value;
        },
        enumerable: true,
        configurable: true
    });
    return FrameworkCategoryMeta;
}());
exports.FrameworkCategoryMeta = FrameworkCategoryMeta;
//# sourceMappingURL=framework.model.js.map